import {Component, OnInit,Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';


export interface DialogData {
  animal: string;
  name: string;
}
@Component({
  selector: 'Agedialog-modal',
  templateUrl: 'Agedialog.component.html',
})

export class AgeDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<AgeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}